import { Error } from '@mui/icons-material'
import MenuItem from '@mui/material/MenuItem'
import Select, { SelectChangeEvent } from '@mui/material/Select'
import moment from 'moment'
import { datasetPhases } from '@global/constants/datasetPhases'
import { Submission } from '@global/types'
import * as css from './styled'
import { t } from '@lingui/core/macro'

interface SubmissionSelectProps {
  onChange: (event: SelectChangeEvent) => void
  value: string | number | undefined
  submissions: Submission[]
}

export const SubmissionSelect = ({ onChange, value, submissions }: SubmissionSelectProps) => {
  return (
    <css.StyledFormControl variant="standard">
      <Select value={value as string} onChange={onChange}>
        {submissions.map(({ created_at, submitted_by_user, id, phase }) => (
          <MenuItem value={id} key={id}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {phase === String(datasetPhases.REJECTED) ? (
                <Error color="error" sx={{ marginRight: '10px' }} />
              ) : null}
              {submitted_by_user?.name} {t`submitted on`}{' '}
              {moment(created_at).format('MM/DD/YY [at] h:mm:ss a')}
            </div>
          </MenuItem>
        ))}
      </Select>
    </css.StyledFormControl>
  )
}
